import React, { useEffect, useState } from 'react';
import TestCycleFilterForm from './TestCycleFilterForm';
import Modal from '../../../elements/Modal';
import { Button } from '@mui/material';

const TestCycleFilterModal = ({
  showModal,
  handleClose,
  statuses,
  purposeOptions,
  typeOptions,
  projectUsers,
  loading,
  filters,
  setFilters,
  addNotification,
  setPage,
}) => {
  const defaultFilters = {
    purpose: filters.purpose || 'All',
    status: filters.status || 'All',
    type: filters.type || 'All',
    owner: Array.isArray(filters.owner) ? filters.owner : [],
  };
  const [formData, setFormData] = useState(defaultFilters);

  const handleFormSubmit = async () => {
    try {
      const filters = { ...formData };
      setFilters(filters);
      setPage(1);
      handleClose();
      addNotification('success', 'Filters applied successfully.');
    } catch (error) {
      const errorMessage =
        error?.message || 'Unable to apply filters to test cycles.';
      addNotification('danger', errorMessage);
    }
  };

  const handleCloseModal = () => {
    handleClose();
  };

  useEffect(() => {
    setFormData(defaultFilters);
  }, [showModal]);

  return (
    <Modal
      open={showModal}
      handleClose={handleCloseModal}
      modalTitle="Filter Test Cycles"
      action={() => (
        <>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            title="Click to  apply filter"
            onClick={handleFormSubmit}>
            Apply
          </Button>
        </>
      )}>
      <TestCycleFilterForm
        projectUsers={projectUsers}
        statuses={statuses}
        purposeOptions={purposeOptions}
        typeOptions={typeOptions}
        loading={loading}
        formData={formData}
        setFormData={setFormData}
      />
    </Modal>
  );
};

export default TestCycleFilterModal;